import * as Sentry from '@sentry/react';
import { Routes, createBrowserRouter } from 'react-router-dom';

export const ignoreErrorsList = ['Network Error', 'Failed to load resource', 'Failed to fetch'];

export const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);
